import React from "react";
import contextProvider from "app/contextProvider";
import { withRouter, Link } from "react-router-dom";

import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";

import Section from "app/_L1_components/Layout/Section";
import Panel from "app/_L1_components/Layout/Panel";
import ReactOForm from "app/_L1_components/Elements/ReactOForm";
import ReactOFormInput from "app/_L1_components/Elements/ReactOFormInput";
import ReactOButton from "app/_L1_components/Elements/ReactOButton";

import ReactOTable from "app/_L1_components/Elements/ReactOTable";
import ReactOModal from "app/_L1_components/Elements/ReactOModal";

class ProbConf extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      loading_probes: false,
      data: null,
    };
    super(props, initState);
    this.apiStore = null;
    this.actionsShelf = null;
    this._REFRESH_TOUT = null;
    this._LOADING_ENABLED = true;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.apiStore = this.getAppContext().getApiStoreService();
    this.loadProbesConf(null, true);
  }

  onComponentWillUnmount() {}

  loadProbesConf(cb, fast) {
    if (this._REFRESH_TOUT) {
      clearTimeout(this._REFRESH_TOUT);
    }
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("probes", {
          data: {
            fast: fast ? "1" : "0",
          },
          ___onSuccess: (status, data) => {
            // console.log("sss" + JSON.stringify(this.getAppContext().authHandler.getAccountData().SDmeasure))
            this.setState({
              data: data,
              loading: false,
              loading_probes: false,
            });
          },
        });
      }
    );
  }

  submitConf(data, cb) {
    this.setState(
      {
        loading_probes: true,
      },
      () => {
        this.apiStore.fire("management", {
          data: {
            probeuid: data.prb_id,
            entry_path: "management",
            value: {
              measures_conf: data._configuration,
              probe_status: data._status,
            },
          },
          ___onSuccess: (response_status, response_data) => {
            this.loadProbesConf(null, true);
            if (cb) cb(response_status, response_data[0]);
          },
        });
      }
    );
  }

  onRender() {
    return (
      <Section designType="narrow" className="mt-3">
        <_LoadingWrapper loadingPlug={this.state.loading && this._LOADING_ENABLED}>
          <div className="d-flex py-1">
            <div className="flex-shrink-1 mr-3" style={{ fontSize: "40px" }}>
              <div style={{ display: "inline-block" }}>
                <span className="icon-wrench" style={{ fontSize: "1.25rem" }}></span>
              </div>
              <div style={{ display: "inline-block" }}>
                <h5 className="ml-2">Probes management</h5>
              </div>
            </div>
          </div>
          <Panel bodyClassName="p-0" rounded>
            {this.state.data ? (
              <div>
                <_LoadingWrapper loadingPlug={this.state.loading_probes}>
                  <ReactOTable
                    thClassName="px-3 py-1"
                    tdClassName="align-middle px-3 py-2"
                    compressed={
                      this.getAppContext().media.isMobile ||
                      this.getAppContext().media.isTablet
                    }
                    compressedRowRendering={(row_items) => {
                      return (
                        <div>
                          <div className="mt-2">
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.probes.title}</strong>
                              </small>
                            </div>
                            {row_items.probes.content}
                          </div>
                          <div className="mt-2">
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.measures_conf.title}</strong>
                              </small>
                            </div>
                            {row_items.measures_conf.content}
                          </div>
                          <div className="mt-2">
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.probe_status.title}</strong>
                              </small>
                            </div>
                            {row_items.probe_status.content}
                          </div>
                          <div className="mt-2">{row_items.ctrl.content}</div>
                        </div>
                      );
                    }}
                    thDividers
                    cols={[
                      {
                        title: "Probes",
                        data_key: "probes",
                        align: "center",
                        width: "50",
                        sortable: true,
                      },
                      {
                        title: "Measure configuration",
                        data_key: "measures_conf",
                        align: "center",
                        width: "20",
                        sortable: true,
                      },
                      {
                        title: "Status",
                        data_key: "probe_status",
                        align: "center",
                        width: "20",
                        sortable: true,
                      },
                      ...(this.getAppContext().authHandler.getAccountData().type ==
                      "ADMIN"
                        ? [
                            {
                              title: "",
                              data_key: "ctrl",
                              width: "15",
                              align: "center",
                            },
                          ]
                        : []),
                    ]}
                    rows={(() => {
                      let _TMP = [];
                      this.state.data.forEach((_Curr, _Id) => {
                        _TMP.push({
                          probes: {
                            value: _Curr.name,
                            render: (
                              <div>
                                <Link to={"/" + _Curr.prb_id + "/active"} target="_blank">
                                  <h5>{_Curr.name}</h5>
                                  <span className="sub-title">
                                    {_Curr.prb_id.replace(/(..)/g, "$1:").slice(0, -1)}
                                  </span>
                                </Link>
                              </div>
                            ),
                          },
                          measures_conf: {
                            value: _Curr.measures_conf,
                            render: (
                              <span>
                                {this.getAppContext().conf.SETTINGS_NAME[
                                  _Curr.probe_status
                                ].label == "Not deployed" ||
                                this.getAppContext().conf.SETTINGS_NAME[
                                  _Curr.probe_status
                                ].label == "Maintenance"
                                  ? "(" +
                                    _Curr.measures_conf.charAt(0).toUpperCase() +
                                    _Curr.measures_conf.slice(1) +
                                    ")"
                                  : _Curr.measures_conf.charAt(0).toUpperCase() +
                                    _Curr.measures_conf.slice(1)}
                              </span>
                            ),
                          },
                          probe_status: {
                            value: _Curr.probe_status,
                            render: (
                              <span>
                                {
                                  this.getAppContext().conf.SETTINGS_NAME[
                                    _Curr.probe_status
                                  ].label
                                }
                              </span>
                            ),
                          },
                          ...(this.getAppContext().authHandler.getAccountData().type ==
                            "ADMIN" && {
                            ctrl: (
                              <ReactOButton
                                title="Modify"
                                icon="pencil"
                                color="gray200"
                                size="sm"
                                onClick={() => {
                                  this._config_modal.open(_Curr);
                                }}
                              />
                            ),
                          }),
                        });
                      });
                      return _TMP;
                    })()}
                  />

                  <ReactOModal
                    modalId="probeSetting"
                    size="md"
                    onControllerReady={(modal_context) => {
                      this._config_modal = modal_context;
                    }}
                    onModalMounted={(data) => {
                      this._config_form.init(data);
                    }}
                    header="Edit settings"
                    centered={true}
                    body={(data) => {
                      return (
                        <div>
                          <div>
                            <strong>{data.name}</strong>
                          </div>
                          {data.prb_id.replace(/(..)/g, "$1:").slice(0, -1)}

                          <ReactOForm
                            onControllerReady={(form_controller) => {
                              this._config_form = form_controller;
                            }}
                            onSubmit={(form_data, cb) => {
                              form_data._configuration = this._config_form.getEntry(
                                "conf-" + form_data.prb_id
                              );
                              form_data._status = this._config_form.getEntry(
                                "status-" + form_data.prb_id
                              );
                              this.submitConf(form_data, cb);
                            }}
                          >
                            <ReactOFormInput
                              disabled={
                                this.getAppContext().authHandler.getAccountData()
                                  .SDmeasure != "yes"
                              }
                              className="mt-3"
                              type="select"
                              data_key={"conf-" + data.prb_id}
                              label="Configuration"
                              default={data.measures_conf}
                              options={() => {
                                return [
                                  { name: "Manual", value: "manual" },
                                  { name: "Software Defined", value: "SD" },
                                ];
                              }}
                              onOptionSelect={(form_ctrl, selected_value) => {
                                form_ctrl.handleFormChange(
                                  "conf-" + data.prb_id,
                                  selected_value
                                );
                              }}
                            />
                            <ReactOFormInput
                              className="mt-3"
                              type="select"
                              data_key={"status-" + data.prb_id}
                              label="Probe status"
                              default={data.probe_status}
                              options={() => {
                                return [
                                  { name: "Deployed", value: "deployed" },
                                  { name: "Not deployed", value: "not_deployed" },
                                  { name: "Maintenance", value: "maintenance" },
                                ];
                              }}
                              onOptionSelect={(form_ctrl, selected_value) => {
                                form_ctrl.handleFormChange(
                                  "status-" + data.prb_id,
                                  selected_value
                                );
                              }}
                            />
                          </ReactOForm>
                        </div>
                      );
                    }}
                    actions={[
                      {
                        text: "Cancel",
                        color: "light",
                        action: "close",
                      },
                      (data) => {
                        return {
                          text: "Apply",
                          color: "primary",
                          action: () => {
                            this._config_form.submit((submit_result) => {
                              if (submit_result.status === true) {
                                this._config_modal.close();
                              }
                            });
                          },
                        };
                      },
                    ]}
                  />
                </_LoadingWrapper>
              </div>
            ) : null}
          </Panel>
        </_LoadingWrapper>
      </Section>
    );
  }
}

export default contextProvider(
  withRouter(ProbConf),
  //	withDefinedContext(Account, 'Account', context_exposed_methods),
  {
    define: null,
  }
);
